import React, {useState, useEffect} from 'react';
import './hamburger.styles.scss';
import hamburgerCross from '../../assets/images/hamburger-cross.png';
import cart from '../../assets/images/cart.png';
import {Link } from "gatsby";
import { useContext } from 'react';
import { GlobalStateContext } from '../../context/globalContextProvider';

const Hamburger = () => {
    const [showHamburger, setShowHamburger] = useState(true);
    const { items } = useContext(GlobalStateContext);
    const [itemAmount, setItemAmount] = useState(0)


    useEffect(() => {
        const amount = items.reduce((amount, curr) => {
            amount += Number(curr.qty);
            return amount
        }, 0);
        setItemAmount(amount);

    }, [JSON.stringify(items)])

    const handleShowHamburger = () => {
        setShowHamburger(!showHamburger);
    }

    const closeHamburger = () => {
        setShowHamburger(true);
    }

    return (
        <div className="hamburger-full-page">
            <div className="hamburger-container">
                <div className="logo">
                    
                </div>
                
                {
                showHamburger && 
                <div className="image-side">
                    <div className="hamburger-box"
                        onClick={handleShowHamburger}
                    >
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                    {
                        itemAmount> 0 &&
                            <div className="cart">
                            <Link to="/cart">
                                <img src={cart} />
                                <div className="cart-amount">
                                    <h2>{itemAmount}</h2>
                                </div>
                            </Link>
                        </div>
                    }
                    
                    
                </div>
                
            }

                {
                !showHamburger && 
                
                <div className="image-side">
                    <div className="hamburger-cross"
                        onClick={handleShowHamburger}>
                        <img src={hamburgerCross}
                            alt="hamburger close"/>
                    </div>
                    {
                        itemAmount > 0 &&
                            <div className="cart">
                            <Link to="/cart">
                                <img src={cart} />
                                <div className="cart-amount">
                                    <h2>{itemAmount}</h2>
                                </div>
                            </Link>
                        </div>
                    }
                </div>
                
                
            } 
            
            
            </div>
            
            {
            !showHamburger && <div className="hamburger-links">
                <ul>
                    <Link className="neon" onClick={closeHamburger} activeClassName="active" to="/" data-text="HOME">HOME</Link>
                    <Link className="neon" onClick={closeHamburger}  activeClassName="active" to="/vocal-samples" data-text="SAMPLES">SAMPLES</Link>
                    <Link className="neon" onClick={closeHamburger}  activeClassName="active" to="/work" data-text="WORK">WORK</Link>
                    <Link className="neon" onClick={closeHamburger}  data-text="SAY HI" to="/#contact">SAY HI</Link>
                </ul>
            </div>
        } </div>
    )
}

export default Hamburger;
